import axios from "axios";
import { MAIN_API } from "./apilist";
import { store } from "../redux/store/store";

/* Cliente del organizador para las fichas de cliente del negocio (Beauty, canchas y mesas): /api/organizer/clients.
   Devuelve la respuesta de axios: `data.info` trae el resultado y un error trae `response.data.{ message, codigo }`. */
const BASE = MAIN_API + "/api/organizer/clients";
const authHeader = () => ({ Authorization: `Bearer ${store.getState().auth.accessToken}` });
const cfg = (params) => (params ? { params, headers: authHeader() } : { headers: authHeader() });

export const clientsListApi = ({ q, page, birthdayMonth, duplicates, archived, consent } = {}) =>
  axios.get(
    BASE,
    cfg({
      ...(q ? { q } : {}),
      ...(page > 1 ? { page } : {}),
      ...(birthdayMonth ? { birthdayMonth } : {}),
      ...(duplicates ? { duplicates: 1 } : {}),
      ...(archived ? { archived: true } : {}),
      ...(consent ? { consent } : {}),
    })
  );
export const clientsGetApi = (clientId) => axios.get(`${BASE}/${clientId}`, cfg());
export const clientsUpdateApi = (clientId, data) => axios.patch(`${BASE}/${clientId}`, data, cfg());
export const clientsArchiveApi = (clientId) => axios.post(`${BASE}/${clientId}/archive`, {}, cfg());
export const clientsUnarchiveApi = (clientId) => axios.post(`${BASE}/${clientId}/unarchive`, {}, cfg());
export const clientsMergeApi = (clientId, sourceIds) => axios.post(`${BASE}/${clientId}/merge`, { sourceIds }, cfg());
// Historial de todos los rubros: filas con `kind` ("beauty" | "court" | "table").
export const clientsHistoryApi = (clientId) => axios.get(`${BASE}/${clientId}/history`, cfg());

export const clientsNotesApi = (clientId) => axios.get(`${BASE}/${clientId}/notes`, cfg());
export const clientsAddNoteApi = (clientId, { kind, body }) => axios.post(`${BASE}/${clientId}/notes`, { kind, body }, cfg());
export const clientsUpdateNoteApi = (clientId, noteId, data) => axios.patch(`${BASE}/${clientId}/notes/${noteId}`, data, cfg());
export const clientsArchiveNoteApi = (clientId, noteId) => axios.post(`${BASE}/${clientId}/notes/${noteId}/archive`, {}, cfg());

// Desde una reserva (cancha o mesa; también turnos): ver, crear, vincular o desvincular (solo dueño) la ficha.
export const clientsReservationClientApi = (reservationId) => axios.get(`${BASE}/reservations/${reservationId}/client`, cfg());
export const clientsOpenReservationClientApi = (reservationId, body = {}) =>
  axios.post(`${BASE}/reservations/${reservationId}/client`, body, cfg());
export const clientsLinkReservationClientApi = (reservationId, clientId) =>
  axios.post(`${BASE}/reservations/${reservationId}/client/link`, { clientId }, cfg());
export const clientsUnlinkReservationClientApi = (reservationId) =>
  axios.delete(`${BASE}/reservations/${reservationId}/client/link`, cfg());

// Campañas automáticas (cumpleaños y "te extrañamos"): `type` es "birthday" | "winback".
export const clientsCampaignsApi = () => axios.get(`${BASE}/campaigns`, cfg());
export const clientsCampaignSaveApi = (type, data) => axios.put(`${BASE}/campaigns/${type}`, data, cfg());
// Imagen del mail (multipart, campo `image`): responde `info.url`.
export const clientsCampaignImageUploadApi = (file) => {
  const body = new FormData();
  body.append("image", file);
  return axios.post(`${BASE}/campaigns/images`, body, cfg());
};
export const clientsCampaignPreviewApi = (type) => axios.get(`${BASE}/campaigns/${type}/preview`, cfg());
export const clientsCampaignsSummaryApi = (months = 6) => axios.get(`${BASE}/campaigns/summary`, cfg({ months }));
